import React from "react";
import requestEsriModules from "@mrwa/rime-replacement/infrastructure/esriModules";
import { bufferDistanceMetres } from "../data/gpsData";
import mapHelper from "@mrwa/rime-replacement/infrastructure/mapHelper";

import "./layerDetails.css";

export class LayerDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = { attributeTitles: [], attributeValues: [] };

    this.layerFeatures = [];

    this.gpsDataChanged = this.gpsDataChanged.bind(this);
    this.getNameToAliasMap = this.getNameToAliasMap.bind(this);
    this.determineClosestFeature = this.determineClosestFeature.bind(this);
  }

  async componentDidMount() {
    if (!this.props.playerContext.gpsInformation.allData.length > 0) return;
    this.props.playerContext.onGpsDataChanged(this.gpsDataChanged);
    const getLayerData = async (rimeLayer) => {
      //query layer data for the route
      const bufferedGeometry = await this.props.playerContext.gpsInformation
        .bufferedGeometry;
      if (!bufferedGeometry) return;
      const query = {
        geometry: bufferedGeometry,
        spatialRelationship: "intersects",
        outFields: ["*"],
        returnGeometry: true,
      };
      return (await rimeLayer.layer.queryFeatures(query)).features;
    };
    this.layerFeatures = await getLayerData(this.props.layer);
    this.gpsDataChanged(this.props.playerContext.gpsInformation.current);
  }

  componentWillUnmount() {
    this.props.playerContext.removeOnGpsDataChanged(this.gpsDataChanged);
  }

  async gpsDataChanged(gpsData) {
    const closestFeature = await this.determineClosestFeature(gpsData);
    const mapTitles = this.getNameToAliasMap(closestFeature);
    if (!closestFeature) {
      this.setState({
        attributeValues: [],
        attributeTitles: [],
      });
      return;
    }

    this.setState({
      attributeTitles:
        mapTitles.length === 0 //will default to keys if getNameToAliasMap fails
          ? Object.keys(closestFeature.attributes).slice(1) //removing objectId attribute with slice
          : Object.values(mapTitles).slice(1),
      attributeValues: Object.values(closestFeature.attributes).slice(1),
    });
  }

  getNameToAliasMap(feature) {
    if (!feature) return;
    const layer =
      feature.sourceLayer && mapHelper.esriLayerToLayer(feature.sourceLayer);
    return layer ? layer.nameToAliasMap : null;
  }

  async determineClosestFeature(gpsData) {
    if (!this.layerFeatures.length > 0 || !gpsData) return;
    const { GeometryEngine } = await requestEsriModules({
      GeometryEngine: "esri/geometry/geometryEngineAsync",
    });
    const currentPoint = await gpsData.projectedGeometry;
    const distances = await Promise.all(
      this.layerFeatures.map(
        async (feature) =>
          await GeometryEngine.distance(
            currentPoint,
            feature.geometry,
            "meters"
          )
      )
    );

    const minDistance = Math.min(...distances);
    return (
      minDistance <= bufferDistanceMetres &&
      this.layerFeatures[distances.indexOf(minDistance)]
    );
  }

  render() {
    const hasData =
      this.state.attributeTitles.length + this.state.attributeValues.length > 0;
    return (
      <div className="layerDetailsContainer">
        <table className="layerDetailsTable">
          {hasData ? (
            <tbody>
              <tr className="attributeTitleRow">
                {this.state.attributeTitles.map((title, i) => (
                  <th key={i}>{title}</th>
                ))}
              </tr>
              <tr className="attributeValueRow">
                {this.state.attributeValues.map((value, i) => (
                  <td key={i}>{value}</td>
                ))}
              </tr>
            </tbody>
          ) : (
            <tbody>
              <tr className="attributeTitleRow">
                <td>No current data for this layer</td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    );
  }
}
